<template>
    <div
        :data-component="$options.name"
        class="flex flex-col w-full screen-m:flex-row"
    >
        <div
            v-for="(searchOption, index) in searchOptions"
            :key="searchOption.key"
            class="flex items-center screen-m:basis-1/2 screen-xxl:basis-full"
        >
            <cs-radio-button
                v-model="model"
                name="surrounding-type"
                :value="searchOption.value"
                @update:modelValue="onUpdate"
            >
                {{ searchOption.text }}
            </cs-radio-button>

            <div
                v-if="isScreenM"
                class="relative"
            >
                <cs-tooltip
                    class="z-content-tooltip"
                    position="right"
                    showOnHover
                    @tooltipOpen="isTooltipOpen = true"
                    @update:visible="
                        (value: boolean) => {
                            isTooltipOpen = value
                            $emit('update:visible', value)
                        }
                    "
                >
                    <template #trigger>
                        <ms-information-circle
                            class="hover:cursor-pointer z-[36] ml-5 w-24 h-24 transition-colors"
                            :class="{ 'text-dustygray': !isTooltipOpen }"
                        />
                    </template>
                    <ms-headline
                        type="h4"
                        class="mb-10"
                    >
                        Lorem Headline {{ index }}
                    </ms-headline>
                    <span> Lorem Text</span>
                </cs-tooltip>
            </div>
            <div v-else>
                <ms-information-circle
                    class="hover:cursor-pointer z-[36] ml-5 w-24 h-24 transition-colors"
                    :class="{ 'text-dustygray': !isTooltipOpen }"
                    @click="openModal(index)"
                />
                <cs-tooltip-modal
                    :visible="isModalOpen[index]"
                    @update:visible="onUpdateVisible(index)"
                >
                    <span> Lorem Span {{ index }} </span>
                </cs-tooltip-modal>
            </div>
        </div>
    </div>
</template>
<script lang="ts" src="./CsSurroundingArea.ts" />
